import { HStack, StackProps, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { useSubscribeCartStoreShallow } from '../hooks/cartStoreHooks';
import { cartStoreSelectors } from '../selectors';

const CartTotalPrice = (props: StackProps) => {
  const { t } = useTranslation();
  const totalPrice = useSubscribeCartStoreShallow(cartStoreSelectors.totalPrice);

  return (
    <VStack
      borderTop='1px'
      borderTopColor='gray.200'
      pt={4}
      spacing={2}
      w='full'
      {...props}
    >
      {totalPrice.savings > 0 && (
        <HStack
          color='success.pure'
          fontWeight='semibold'
          justify='space-between'
          w='full'
        >
          <Text>{t('store.cart.pricing.saving')}</Text>
          <Text>-${totalPrice.savings.toFixed(2)}</Text>
        </HStack>
      )}
      <HStack
        align='baseline'
        w='full'
      >
        <Text
          fontSize='lg'
          fontWeight='semibold'
          mr='auto'
        >
          {t('store.cart.pricing.subtotal')}
        </Text>

        {totalPrice.savings > 0 && (
          <Text
            fontSize='sm'
            textDecoration='line-through'
          >
            ${totalPrice.raw.toFixed(2)}
          </Text>
        )}
        <Text
          fontSize='xl'
          fontWeight='bold'
        >
          ${totalPrice.withDiscount.toFixed(2)}
        </Text>
      </HStack>
    </VStack>
  );
};

export default CartTotalPrice;
